var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leads_Icon",
    "data-name": "Leads Icon",
    transform: "translate(-17.799 -17.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2676",
    "data-name": "Group 2676",
    transform: "translate(31.958 30.188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(-13.409 -12.41)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M60.084,69.646c0-.087-.014-.14-.014-.192,0-1.742,0-3.483.014-5.225,0-.529.063-1.058.115-1.588a2.273,2.273,0,0,1,.395-1,4.119,4.119,0,0,1,3.575-2.107c2.555-.024,5.11-.058,7.664-.067,1.049,0,2.1.014,3.147.087a3.879,3.879,0,0,1,2.074.89,4.467,4.467,0,0,1,1.1,1.3,3.482,3.482,0,0,1,.419,1.809c.019,1.448.024,2.9.029,4.349v1.467a.245.245,0,0,1-.269.279c-1.848,0-3.69.019-5.538.019q-4.684,0-9.363-.01c-1.044,0-2.083-.01-3.127-.014H60.08Z",
    transform: "translate(-50.75 -48.664)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M78.967,41.686a4.684,4.684,0,1,1-4.725-4.677,4.606,4.606,0,0,1,4.725,4.677Z",
    transform: "translate(-55.695 -37.01)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M48.143,61.684a.872.872,0,0,1-.067.178,5.01,5.01,0,0,0-.616,2.285c-.024.7-.048,1.4-.063,2.1-.024,1.41-.038,2.815-.053,4.224,0,.308,0,.308-.308.308q-2.555.014-5.11.019c-.346,0-.693-.019-1.044-.014-.149,0-.188-.043-.183-.188.029-1.068.038-2.136.077-3.2.029-.943.077-1.886.125-2.834a2.185,2.185,0,0,1,.544-1.318A4.367,4.367,0,0,1,43.5,61.819a3.478,3.478,0,0,1,.866-.115c1.184-.024,2.372-.034,3.556-.043.058,0,.12.01.221.019Z",
    transform: "translate(-40.699 -49.8)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M109.939,70.79h-6.192c-.053,0-.111-.01-.164,0-.183.019-.221-.072-.226-.241q-.043-3.111-.106-6.226a5.112,5.112,0,0,0-.327-1.8c-.087-.212-.192-.419-.289-.63s-.067-.25.144-.241c1.366.038,2.738.063,4.1.12a2.879,2.879,0,0,1,1.694.789,3.161,3.161,0,0,1,1.16,1.665,5.356,5.356,0,0,1,.168,1.169c.029,1.771.034,3.536.048,5.307a.808.808,0,0,1-.014.087Z",
    transform: "translate(-72.81 -49.794)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M53.593,41.615a3.936,3.936,0,0,1,3.276,1.4,3.882,3.882,0,0,1,.895,1.833,4.026,4.026,0,0,1-.322,2.738.414.414,0,0,1-.217.159c-.481.188-.977.342-1.453.548a5.574,5.574,0,0,0-1.554,1.073c-.183.168-.37.342-.568.5a.355.355,0,0,1-.236.067A4.38,4.38,0,0,1,50.4,48.322a3.921,3.921,0,0,1-.794-3.565,4.2,4.2,0,0,1,1.9-2.574,3.253,3.253,0,0,1,2.088-.563Z",
    transform: "translate(-45.249 -39.392)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M95.907,41.57a4.5,4.5,0,0,1,2.16.505A4.346,4.346,0,0,1,100,44.264a3.869,3.869,0,0,1,.2,2.026,4.058,4.058,0,0,1-1.41,2.593,4.445,4.445,0,0,1-2.367,1.025.493.493,0,0,1-.428-.13c-.38-.337-.765-.678-1.169-.986a8.442,8.442,0,0,0-2.189-1.03.743.743,0,0,1-.462-.452,3.95,3.95,0,0,1-.241-2.377,4.1,4.1,0,0,1,2.637-3.118,6.422,6.422,0,0,1,1.338-.255Z",
    transform: "translate(-67.237 -39.371)",
    fill: "#a5551c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2677",
    "data-name": "Group 2677",
    transform: "translate(31.276 51.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M75.264,82.6a5.774,5.774,0,0,1-11.547,0h-2a7.765,7.765,0,1,0,15.531,0h-2Z",
    transform: "translate(-50.909 -82.6)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M74.216,82.6a10.859,10.859,0,1,1-21.718,0H49.9a13.457,13.457,0,1,0,26.914,0h-2.6Z",
    transform: "translate(-44.776 -82.6)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M74.021,82.6h0a16.19,16.19,0,1,1-32.38,0H39.25a18.581,18.581,0,0,0,37.162,0H74.021Z",
    transform: "translate(-39.25 -82.6)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M71.44,82.6a3.094,3.094,0,1,0,6.187,0H71.44Z",
    transform: "translate(-55.952 -82.6)",
    fill: "#a5551c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.4256afa358245f349bf30a29991cf968.svg";
export { ForwardRef as ReactComponent };